import React from "react";
import { PILLARS } from "@/lib/content";
import { TrendingUp, HeartPulse, Building2, Check, ArrowUpRight } from "lucide-react";

const ICONS = { TrendingUp, HeartPulse, Building2 };

const Pillars = () => {
  return (
    <section
      id="servicios"
      data-testid="pillars-section"
      className="relative bg-[#0B0410] text-[#F9F6F0] py-24 lg:py-32 overflow-hidden grain border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#E6D5B8]" />
              <span
                className="text-[11px] tracking-luxury uppercase text-[#E6D5B8] font-medium"
                data-testid="pillars-eyebrow"
              >
                Servicios & productos
              </span>
            </div>
            <h2
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08]"
              data-testid="pillars-headline"
            >
              Tres pilares,{" "}
              <span className="italic text-[#E6D5B8]">trece soluciones</span>{" "}
              concretas.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base lg:text-lg text-[#F9F6F0]/70 font-light">
              Cada estrategia parte de uno de tres pilares: ahorro & inversión,
              vida & salud, patrimoniales & daños. Detrás de cada pilar, un
              catálogo curado de productos institucionales para diseñar tu
              plan exacto.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {PILLARS.map((p, idx) => {
            const Icon = ICONS[p.icon] || TrendingUp;
            return (
              <article
                key={p.key}
                data-testid={`pillar-card-${p.key}`}
                className="group relative bg-[#150A1F] border border-[#2A0A4A] rounded-sm p-8 lg:p-10 hover:border-[#E6D5B8]/40 transition-all duration-500 hover:-translate-y-1 flex flex-col"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#3D1565]/20 border border-[#3D1565] rounded-sm">
                    <Icon size={24} className="text-[#E6D5B8]" />
                  </div>
                  <span className="text-[11px] tracking-luxury uppercase text-[#A397B4]">
                    0{idx + 1}
                  </span>
                </div>

                <h3
                  data-testid={`pillar-title-${p.key}`}
                  className="font-display text-3xl lg:text-4xl font-light leading-tight"
                >
                  {p.title}
                </h3>

                <p className="mt-4 text-sm lg:text-base text-[#F9F6F0]/70 leading-relaxed font-light">
                  {p.description}
                </p>

                <div className="mt-8 pt-6 border-t border-white/10 flex-1">
                  <div className="text-[10px] tracking-luxury uppercase text-[#E6D5B8] mb-4">
                    Productos
                  </div>
                  <ul className="space-y-3">
                    {p.items.map((it) => (
                      <li
                        key={it}
                        data-testid={`pillar-${p.key}-item`}
                        className="text-sm text-[#F9F6F0]/85 flex items-start gap-3"
                      >
                        <Check
                          size={15}
                          className="text-[#E6D5B8] shrink-0 mt-0.5"
                          strokeWidth={2}
                        />
                        <span className="font-light">{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="absolute top-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <ArrowUpRight size={18} className="text-[#E6D5B8]" />
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-14 text-center">
          <p className="text-sm text-[#F9F6F0]/55 max-w-2xl mx-auto">
            ¿No estás seguro qué producto te conviene? Lo definimos juntos en
            la asesoría inicial — sin costo y sin compromiso.
          </p>
          <div className="mt-8">
            <button
              data-testid="pillars-cta-agendar"
              onClick={() => {
                const el = document.getElementById("contacto");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center gap-2 bg-[#3D1565] hover:bg-[#4a1c79] text-white text-sm tracking-wider uppercase px-8 py-4 rounded-sm transition-all duration-300 hover:-translate-y-0.5"
            >
              Agendar asesoría
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pillars;
